import { SET_NAME_FOR_ADDRESS } from '../storage/AddressToNameReducer';
import Storage from '../storage/Storage';
import isContractInitialized from './ContractInitializationState';

export default class AddressToNameService {
  constructor () {
    this.contractLoaded = false;
  }

  init () {
    this.storageUnsubscribe = Storage.subscribe(
      () => isContractInitialized() && !this.contractLoaded && this.initService());
  }

  initService () {
    this.contractLoaded = true;
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  setNameForAddress (address, name) {
    Storage.dispatch({type: SET_NAME_FOR_ADDRESS, payload: {address: address, name: name}});
  }

  getNameForAddress (address) {
    if (address === null) {
      return null;
    }

    let name = Storage.getState().addressToName[address];

    if (name === undefined || name === null) {
      this.getNameForAddressFromEthereum(address);
      name = null;
    }

    return name;
  }

  getNameForAddressFromEthereum (address) {
    if (!this.contractLoaded) {
      return null;
    }

    window.contract
      .methods
      .getAddressName(address)
      .call({from: Storage.getState().account.currentAccount}, (err, name) => {
        if (name === undefined || name === null) {
          return null;
        }

        this.setNameForAddress(address, name);
      });

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/AddressToNameService.js